import { ToastContainer, toast } from "react-toastify";
import { TextField } from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Loader from '../Assets/Loader'
import Lottie from 'lottie-react';

export default function Contact() {
    const [clientName, setClientName] = useState('');
    const [clientEmail, setClientEmail] = useState('');
    const [clientNo, setClientNo] = useState('');
    const [clientMssg, setClientMssg] = useState('');
    const [errors, setErrors] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleclientNameChange = (e) => {
        const selectedValue = e.target.value;
        setClientName(selectedValue);
        setErrors((prevErrors) => ({
            ...prevErrors,
            clientName: selectedValue ? '' : 'Name Is Required'
        }))
    };

    const handleclientEmailChange = (e) => {
        const selectedValue = e.target.value;
        setClientEmail(selectedValue);
        setErrors((prevErrors) => ({
            ...prevErrors,
            clientEmail: selectedValue ? '' : 'Email Address Is Required'
        }))
    };

    const handleclientNoChange = (e) => {
        const selectedValue = e.target.value;
        setClientNo(selectedValue);
        setErrors((prevErrors) => ({
            ...prevErrors,
            clientNo: selectedValue ? '' : 'Contact Number Is Required'
        }))
    };

    const handleclientMssgChange = (e) => {
        setClientMssg(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (isSubmitting) return;

        if (!clientName || !clientEmail || !clientNo) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                clientName: !clientName ? "Name is required" : prevErrors.clientName,
                clientEmail: !clientEmail ? "Email Address is required" : prevErrors.clientEmail,
                clientNo: !clientNo ? "Mobile Number is required" : prevErrors.clientNo,
            }));
            setLoading(false);
            return;
        }

        setIsSubmitting(true);
        try {
            const response = await fetch(`https://mailing.rayaninfosolutions.in/api/send-message`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ clientName, clientEmail, clientNo, clientMssg }),
            });

            const data = await response.json(); 
            if (response.ok && data.name && data.number) {
                await sendThanksMssg(data.name, data.number);
            } else {
                toast.error(data.error || "Failed to send lead message.");
            }
        } catch (error) {
            console.error('Error uploading data:', error);
            toast.error("Something went wrong!");
        } finally {
            setIsSubmitting(false);
            setLoading(false);
        }
    };

    const sendThanksMssg = async (name, number) => {
        try {
            const response = await fetch(`https://mailing.rayaninfosolutions.in/api/send-thanks-message`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, number }),
            });

            const data = await response.json();

            if (response.ok) {
                toast.success(data.message);
                setClientName('');
                setClientEmail('');
                setClientNo('');
                setClientMssg('');
            } else {
                toast.error(data.error || "Thank you message failed.");
            }
        } catch (error) {
            console.error('Error sending thanks message:', error);
            toast.error("Something went wrong!");
        }
    };


    return (
        <>
            <section id="ContactUs" className="contact">
                <div className="container my-5" data-aos="fade-up">
                    <div className="section-title">
                        <h2>Contact</h2>
                        <p>Feel free to contact us for any query</p>
                    </div>
                    <div className="row" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-lg-6">
                            <div className="info-box mb-4">
                                <i className="bi bi-geo-alt-fill"></i>
                                <h3>Our Address</h3>
                                <p>501, PLOT NO 40, KAILASH VIHAR, JAJMAU, KANPUR, UTTAR PRADESH, INDIA – 208010</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="info-box  mb-4">
                                <i className="bi bi-envelope-at-fill"></i>
                                <h3>Email Us</h3>
                                <p><Link className='nav-link' to="mailto:rayaninfosolutions@gmail.com">rayaninfosolutions@gmail.com</Link></p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="info-box  mb-4">
                                <i className="bi bi-telephone-outbound-fill"></i>
                                <h3>Call Us</h3>
                                <p><Link className='nav-link' to="tel:+919670796799">+91 96707 96799</Link></p>
                            </div>
                        </div>
                    </div>
                    <div className="row" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-lg-6 ">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3573.3462097191145!2d80.40562501503439!3d26.41230198334566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf70190348c558f34!2sRayan%20Info%20Solutions!5e0!3m2!1sen!2sin!4v1611249705032!5m2!1sen!2sin" width="600" height="450" style={{ border: '0', width: '100%', height: '100%' }} allowFullScreen="" title='google-map' loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        <div className="col-lg-6">
                            <h3 style={{ textAlign: 'center', color: '#106eea' }}>Schedule A Free Demo !</h3>
                            <form className='php-email-form' onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="col form-group">
                                        <TextField label='Name' variant="outlined" fullWidth value={clientName} onChange={handleclientNameChange} helperText={errors.clientName} error={!!errors.clientName} />
                                    </div>
                                    <div className="col form-group">
                                        <TextField label='Email' variant="outlined" fullWidth value={clientEmail} onChange={handleclientEmailChange} helperText={errors.clientEmail} error={!!errors.clientEmail} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <TextField label='Number' variant="outlined" type="number" fullWidth value={clientNo} onChange={handleclientNoChange} helperText={errors.clientNo} error={!!errors.clientNo} />
                                </div>
                                <div className="form-group">
                                    <textarea className="form-control" name="message" rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message" value={clientMssg} onChange={handleclientMssgChange} required ></textarea>
                                    <div className="validate"></div>
                                </div>
                                <div className="form-group d-none">
                                    <input type="text" className="form-control" name="first_name" />
                                    <div className="validate"></div>
                                </div>
                                <div className="text-center"><button type="submit" name="submit" onClick={handleSubmit}>Send Message</button></div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            {loading && (
                <div className="modal-backdrop show"></div>
            )}
            <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="loading-area">
                    <Lottie animationData={Loader} loop={true} autoplay={true} style={{ width: '100%', height: 'auto', maxWidth: '250px' }} />
                </div>
            </div>
            <ToastContainer />
        </>
    )
}
